import React, { ForwardedRef, forwardRef } from 'react';
import { AnyType } from '@src/models/common';

import styled from './DatePickerEmptyPlaceholder.module.scss';

export const DatePickerEmptyPlaceholder = forwardRef(
  ({ className, onClick, disabled }: AnyType, ref: ForwardedRef<HTMLButtonElement>) => (
    <button className={`${className} ${styled.root}`} ref={ref} onClick={onClick} disabled={disabled} />
  ),
);
